import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
export type ReportMismatchMutationVariables = Types.Exact<{
	input: Types.ReportMismatchInput;
}>;

export type ReportMismatchMutation = { __typename?: 'Mutation'; reportMismatch: boolean };

export const ReportMismatchDocument = gql`
	mutation ReportMismatch($input: ReportMismatchInput!) {
		reportMismatch(input: $input)
	}
`;
